import React, { useEffect, useState } from "react";
import classes from "./AdminProfileEdit.module.css";
import { useForm } from "react-hook-form";
import CryptoJS from "crypto-js";
import { useDispatch, useSelector } from "react-redux";
import { data } from "../../../slice/adminSlice";
import ReactTimeAgo from "react-time-ago";
import Close from "../icons/Close";

const AdminProfileEdit = () => {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState();
  const [file, setFile] = useState(null);
  const [blob, setBlob] = useState();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [id, setId] = useState("");
  const [adminImage, setAdminImage] = useState(null);
  const [adminDetails, setAdminDetails] = useState({});
  const details = useSelector((state) => state.adminDetails);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  let user = "";
  let bytes = "";

  useEffect(() => {
    user = localStorage.getItem("user");
    bytes = CryptoJS.AES.decrypt(user, "thisistest");
    const adminId = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    setId(adminId);

    if (!file) {
      (async () => {
        const response = await fetch(`${process.env.REACT_APP_API_URL}get-admin`, {
          method: "POST",
          body: JSON.stringify({ id: adminId }),
          headers: {
            "Content-Type": "application/json",
          },
        });

        if (response.status === 200) {
          const data = await response.json();
          setAdminImage(data.details[0].profile);
          setEmail(data.details[0].email);
          setName(data.details[0].name);
        }
      })();
    }

    if (!file) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const imgSvgHandler = () => {
    setAdminImage(null);
    setPreview(undefined);
  };

  const formSubmitHandler = async (e) => {
    // let fileToUpload = e.target.files.item(0);
    // let reader = new FileReader();
    // reader.onload = (event) => {
    //   setFile({
    //     blob: event.target.result,
    //     details: {
    //       type: file.type,
    //       name: file.name,
    //       size: file.size,
    //     },
    //   });
    // };
    // reader.readAsDataURL(fileToUpload);

    const formData = new FormData();
    formData.append("profile", file);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("id", id.id);
    // formData.append("blob", blob);

    const response = await fetch(`${process.env.REACT_APP_API_URL}edit-admin`, {
      method: "POST",
      body: formData,
    });

    const dataa = await response.json();
    dispatch(data(dataa.detail));
  };

  useEffect(() => {
    setAdminDetails(details.data);
  }, [details]);

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4">
            <h4 className="fs-20 font-w600 mb-0 me-auto">Admin Profile</h4>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Admin Profile</h5>
                </div>
                <form onSubmit={handleSubmit(formSubmitHandler)}>
                  <div className="card-body">
                    <div className="basic-form">
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Profile
                        </label>
                        <div className="col-sm-9">
                          {adminImage && (
                            <div className={classes.adminProfileImg}>
                              <img
                                src={process.env.REACT_APP_IMAGE_URL + "profile-images/"+ adminImage}
                                alt="Admin"
                              />
                              <Close imgSvgHandler={imgSvgHandler} />
                            </div>
                          )}
                          {preview && (
                            <div className={classes.adminProfileImg}>
                              <img src={preview} alt="Admin" />
                              <Close imgSvgHandler={imgSvgHandler} />
                            </div>
                          )}
                          {!preview && !adminImage && (
                            <input
                              type="file"
                              accept="image/*"
                              {...register("profile", { required: true })}
                              onChange={(e) => {
                                // let reader = new FileReader();
                                // reader.onload = (event) => {
                                //   setBlob(event.target.result);
                                // };
                                // reader.readAsDataURL(e.target.files[0]);
                                setFile(e.target.files[0]);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">Name</label>
                        <div className="col-sm-9">
                          <input
                            type="text"
                            className="form-control"
                            {...register("name", { required: true })}
                            placeholder="Name"
                            defaultValue={name}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">Email</label>
                        <div className="col-sm-9">
                          <input
                            type="email"
                            className="form-control"
                            {...register("email", { required: true })}
                            placeholder="Email"
                            defaultValue={email}
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-sm-flex justify-content-between align-items-center">
                    <div className="card-footer-link mb-4 mb-sm-0">
                      <p className="card-text text-dark d-inline">
                        Last updated{" "}
                        {adminDetails && adminDetails.updateDate && (
                          <ReactTimeAgo
                            date={adminDetails.updateDate}
                            locale="en-US"
                          />
                        )}
                      </p>
                    </div>
                    <button className="btn btn-primary" type="submit">
                      update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdminProfileEdit;
